import PageContent from './pageContent';

app.initializers.add('morphdev/landing', () => {
  app.routes['morphdev.landing'] = { path: '/welcome', component: PageContent };
});








// <p class='title-items'>Member For A Day</p> 
